export default "__VITE_ASSET__736db3bd__"